<template>
		<div class="col-lg-12 col-md-13 col-sm-12 mb-3">
		<loader v-if="pageLoader"></loader>
			<div class="step2Booking bg-white p-3" v-if="checkObtCall.obtCallInfo.length == 0">
				<div class="row mb-4">
	                <div class="col-12 ">
	                    <div class="border-bottom mb-3 pb-3 Title-Area">
	                        <h3 class="mb-0">Select Date </h3>
	                    </div>
	                </div>
	                <div class="col-12">
	                    <div class="row">
	                        <div class="col-md-6">
	                            <div class="form-group selectAppointment">
	                                <datepicker v-model="select_date" :lang="lang" :editable="false"  :open="true" :shortcuts= "[]" placeholder="Select date" name="date" format="DD-MM-YYYY" ref="startDateInput" :disabled-days="disabledDates" v-validate="'required'"></datepicker>
	                                <p class="error" v-if="submitted" v-for="error in errors.collect('date')">{{ error }}</p>
	                            </div>
	                        </div>
	                    </div>
	                    <div class="row ">
	                        <div class="col-12 ">
	                            <div class="border-bottom mb-3 pb-3 Title-Area">
	                                <h3 class="mb-0">Select Time</h3>
	                            </div>
	                        </div>
	                        <div class="col-12">
	                            <input type="hidden" name="slot" v-model="avaiable_slots" v-validate="'required'">
	                            <ul class="select-book d-flex align-items-center flex-wrap" v-if="totalSlotList.length > 0">
	                                <li class="mb-3" v-for="list in totalSlotList" :class="[{'booked active':avaiable_slots == list.id}]">
	                                    <a href="javascript:void(0)" @click="avaiable_slots = list.id">{{formatSlot(list.slot)}}
	                                        <span class="list-Circle" v-if="avaiable_slots == list.id"><feather type="check"></feather></span>
	                                    </a>
	                                </li>
	                            </ul>
	                            <p class="error" v-if="submitted" v-for="error in errors.collect('slot')">{{ error }}</p>
	                        </div>
	                    </div>
	                </div>
	                <div class="d-flex align-items-center col-12">
	                    <div class=" button-bottom d-flex justify-content-center ml-2" @click="BookObtCall()"><a href="javascript:void(0)" class="btn btn-blue save">Confirm</a></div>
	                </div>
	            </div>
			</div>
			<div  class="appointment-type justify-content-center d-flex text-center bg-white p-4 border-radius-5" v-if="checkObtCall.obtCallInfo.length > 0">
				<p>Your OnBoarding Call has been scheduled successfully on <span class="font-weight-bold">{{checkObtCall.obtCallInfo[0].obtCallRegisterDate | moment('DD MMM YYYY')}} at {{checkObtCall.obtCallInfo[0].obtCallRegisterDate | moment('hh:mm a')}}</span>.</p>
			</div>
		</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'Obt-Call',
        data() {
        	return {
        		lang: 'en',
        		select_date : '',
        		avaiable_slots : '',
        		submitted : false,
        		pageLoader : false,
        	}

        },
        methods:{
        	disabledDates(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date < today|| moment(date).day() == 0// || moment(date).day() == 6  
            },
            formatSlot(val){
                let date = new Date()
                date.setHours(val.split('.')[0])
                date.setMinutes(val.split('.')[1])
                return moment(date).format('h:mm a')
            },
            BookObtCall(){
            	const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                    	let val = this.totalSlotList.filter(val => val.id == this.avaiable_slots)[0]
                    	let date = new Date()
                    	date.setHours(val.slot.split('.')[0])
                    	date.setMinutes(val.slot.split('.')[1])
                    	let time = moment(date).format('hh:mm:ss')
                    	let input_json = {
	                        'globalParams' : {
	                            "datetime": moment(this.select_date).format('YYYY-MM-DD') +' '+ time,
	                        },
	                        'localParams' :{'parameter' : this}
	                    }
	                    this._runBookObtCall(input_json)
                    }
                });
            },
            reset(){
            	this.submitted = false
            	this.select_date = ''
            	this.avaiable_slots = ''
            }
        },
        
    }
</script>


// WEBPACK FOOTER //
// src/components/website/obtCall/obt-call.vue